import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const costs = [{
  icon: '⏱️',
  label: 'Ore perse a decidere cosa mangiare',
  value: "Oltre 150 ore l'anno"
}, {
  icon: '🛒',
  label: 'Alimenti comprati e mai utilizzati',
  value: 'Centinaia di euro sprecati'
}, {
  icon: '🧠',
  label: 'Nebbia mentale ogni pomeriggio',
  value: 'Produttività dimezzata'
}, {
  icon: '😴',
  label: 'Sonno compromesso',
  value: 'Cene pesanti ogni sera'
}, {
  icon: '❤️',
  label: 'Tempo sottratto a te stesso',
  value: 'Il costo più alto di tutti'
}];
const comparisons = [{
  bad: 'Frigorifero pieno, nessuna idea',
  good: 'Sai sempre cosa preparare'
}, {
  bad: 'Snack improvvisati ogni giorno',
  good: 'Spuntini sani già pianificati'
}, {
  bad: 'Gonfiore e pesantezza costante',
  good: 'Leggerezza dalla prima settimana'
}, {
  bad: 'Spesa disorganizzata e costosa',
  good: 'Lista della spesa già pronta'
}, {
  bad: 'Diete che durano tre giorni',
  good: 'Un metodo che mantieni per anni'
}, {
  bad: 'Ogni lunedì ricomincia da zero',
  good: 'Un sistema che funziona ogni giorno'
}];
export function ComparisonTable() {
  return <section className="py-12 px-4 bg-brand-warm" data-id="element-51">
      <div className="max-w-xl mx-auto space-y-16" data-id="element-52">
        {/* Cost Table */}
        <div data-id="element-53">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl sm:text-3xl font-serif font-bold text-center mb-8 text-brand-text-main" data-id="element-54">
            Quanto ti costa ogni anno non avere un sistema?
          </motion.h2>

          <div className="bg-white rounded-2xl shadow-sm border border-brand-sage/20 overflow-hidden" data-id="element-55">
            <div className="divide-y divide-brand-sage/10" data-id="element-56">
              {costs.map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.05
            }} className="flex flex-col sm:flex-row sm:items-center justify-between p-4 gap-2 sm:gap-4 hover:bg-brand-sage-light transition-colors" data-id="element-57">
                  <div className="flex items-center gap-3" data-id="element-58">
                    <span className="text-xl" data-id="element-59">{item.icon}</span>
                    <span className="font-medium text-brand-text-main" data-id="element-60">
                      {item.label}
                    </span>
                  </div>
                  <span className="text-sm font-bold text-brand-text-muted sm:text-right" data-id="element-61">
                    {item.value}
                  </span>
                </motion.div>)}
            </div>
          </div>
        </div>

        {/* Quote */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-xl font-serif font-bold text-brand-olive italic" data-id="element-62">
          "Non è una questione di motivazione. È una questione di sistema."
        </motion.p>

        {/* Comparison Table */}
        <div data-id="element-63">
          <div className="grid grid-cols-2 gap-4 mb-4 text-center" data-id="element-64">
            <div className="font-bold text-brand-text-muted text-sm uppercase tracking-wider" data-id="element-65">
              ❌ SENZA IL METODO
            </div>
            <div className="font-bold text-brand-olive text-sm uppercase tracking-wider" data-id="element-66">
              ✅ CON METODO MEDITERRANEO™
            </div>
          </div>

          <div className="space-y-3" data-id="element-67">
            {comparisons.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="grid grid-cols-2 gap-4 bg-white border border-brand-sage/20 rounded-xl p-4 items-center" data-id="element-68">
                <div className="text-brand-text-muted text-sm sm:text-base pr-2 border-r border-brand-sage/20" data-id="element-69">
                  {item.bad}
                </div>
                <div className="text-brand-olive font-bold text-sm sm:text-base pl-2" data-id="element-70">
                  {item.good}
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}